import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert } from '@mui/material';
import ImageUpload from './ImageUpload';
import { useLigaImageUpload } from '../../hooks/useLigaImageUpload';
import type { Liga } from '../../types/liga';

interface LeagueImageDialogProps {
  open: boolean;
  liga: Liga | null;
  onClose: () => void;
  onUpdate: (updatedLiga: Liga) => void;
}

const LeagueImageDialog: React.FC<LeagueImageDialogProps> = ({
  open,
  liga,
  onClose,
  onUpdate,
}) => {
  const { uploadImagem, uploadBanner, loading, error } = useLigaImageUpload();

  const handleImageUpload = async (file: File): Promise<string> => {
    if (!liga) throw new Error('Liga não selecionada.');
    
    const updatedLiga = await uploadImagem(liga.id, file);
    onUpdate(updatedLiga);
    return updatedLiga.imagemUrl || '';
  };

  const handleBannerUpload = async (file: File): Promise<string> => {
    if (!liga) throw new Error('Liga não selecionada.');
    
    const updatedLiga = await uploadBanner(liga.id, file);
    onUpdate(updatedLiga);
    return updatedLiga.bannerUrl || '';
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Gerenciar Imagens - {liga?.nome}
      </DialogTitle>
      
      <DialogContent>
        {error && (
          <Alert severity="error" className="mb-3">
            {error}
          </Alert>
        )}
        
        <ImageUpload
          currentImageUrl={liga?.imagemUrl || undefined}
          onUpload={handleImageUpload}
          label="Imagem da Liga"
          maxSizeMB={2}
        />
        
        <ImageUpload
          currentImageUrl={liga?.bannerUrl || undefined}
          onUpload={handleBannerUpload}
          label="Banner da Liga"
          maxSizeMB={5}
        />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeagueImageDialog;